import React from 'react';
import ReactECharts from 'echarts-for-react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const Tokenomics = () => {
  const chartOptions = {
    tooltip: {
      trigger: 'item',
      padding: 15,
      backgroundColor: 'rgba(3,0,20,0.95)',
      textStyle: { color: '#fff' }
    },
    series: [{
      type: 'pie',
      radius: ['60%', '85%'],
      avoidLabelOverlap: false,
      itemStyle: {
        borderRadius: 10,
        borderColor: '#030014',
        borderWidth: 8
      },
      label: { show: false },
      data: [
        { value: 241811111, name: 'Founder / Treasury', itemStyle: { color: '#a855f7' } },
        { value: 155555555, name: 'Liquidity', itemStyle: { color: '#06b6d4' } },
        { value: 117777777, name: 'Community + Ecosystem', itemStyle: { color: '#10b981' } },
        { value: 154444444, name: 'Marketing / Partnerships', itemStyle: { color: '#f59e0b' } },
        { value: 38888888, name: 'Advisory Council', itemStyle: { color: '#ec4899' } }
      ]
    }]
  };

  return (
    <section className="py-32 px-4 bg-[#05001a]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <h2 className="text-5xl md:text-6xl font-extrabold mb-6 uppercase tracking-tighter">Tokenomics 101</h2>
          <div className="flex flex-col md:flex-row items-center justify-center gap-6">
             <div className="px-6 py-2 rounded-full border border-purple-500/30 bg-purple-500/10">
                <p className="text-purple-400 font-mono text-lg tracking-widest">777,777,777 INITIAL SUPPLY</p>
             </div>
             <div className="px-6 py-2 rounded-full border border-green-500/30 bg-green-500/10">
                <p className="text-green-400 font-mono text-lg tracking-widest">708,477,777 POST-BURN SUPPLY</p>
             </div>
          </div>
        </div>

        <div className="grid lg:grid-cols-2 gap-20 items-center">
          <div className="relative h-[500px]">
            <ReactECharts option={chartOptions} style={{ height: '100%' }} />
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center">
              <p className="text-slate-500 text-sm uppercase tracking-widest font-bold">Verified Supply</p>
              <p className="text-3xl font-black text-white uppercase tracking-tighter">Fixed</p>
            </div>
          </div>

          <div className="grid sm:grid-cols-2 gap-4">
            {[
              { l: 'Founder / Treasury', v: '241,811,111 DKT', c: '#a855f7', p: '34.1%' },
              { l: 'Liquidity', v: '155,555,555 DKT', c: '#06b6d4', p: '21.9%' },
              { l: 'Community + Ecosystem', v: '117,777,777 DKT', c: '#10b981', p: '16.6%' },
              { l: 'Marketing / Partnerships', v: '154,444,444 DKT', c: '#f59e0b', p: '21.8%' },
              { l: 'Advisory Council', v: '38,888,888 DKT', c: '#ec4899', p: '5.5%' }
            ].map((item, i) => (
              <motion.div key={i} whileHover={{ y: -5 }} className="p-6 glass-panel rounded-3xl border-white/5">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-3 h-3 rounded-full" style={{ background: item.c }} />
                  <span className="text-slate-400 font-bold uppercase text-[10px] tracking-widest">{item.l}</span>
                </div>
                <p className="text-xl font-bold text-white mb-1">{item.v}</p>
                <p className="text-[10px] text-slate-500 uppercase font-medium">{item.p} Allocation</p>
              </motion.div>
            ))}
            
            <div className="col-span-full p-8 glass-panel rounded-3xl mt-4 border-dashed border-red-500/30 bg-red-500/5">
              <div className="flex items-center gap-4 mb-3">
                <div className="p-3 bg-red-500/20 rounded-xl">
                  <SafeIcon name="Zap" className="text-red-400 w-6 h-6" />
                </div>
                <div>
                  <h4 className="text-xl font-bold text-white uppercase tracking-tighter">Sacred Burn Results</h4>
                  <p className="text-red-400/80 font-mono text-sm">8.91% of total supply permanently removed</p>
                </div>
              </div>
              <p className="text-slate-500 text-sm leading-relaxed">
                The Sacred Burn Initiative utilizes lunar cycles leading to the August 2026 Solar Eclipse 
                to reduce treasury concentration and establish a deflationary foundation.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Tokenomics;